"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.show)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
            key: 0,
            class: (0, vue_1.normalizeClass)(_ctx.cssClasses)
        }, (0, vue_1.toDisplayString)(_ctx.amount), 3))
        : (0, vue_1.createCommentVNode)("", true);
}
